import { requestWithToken } from '../utilities/request';

const get_common_path = (fieldId) => {
  return `/api/private/fields/${fieldId}/direct_api_settings`
}

// direct利用規約同意API
const agreed_terms = (fieldId) => {
  return requestWithToken({
    method: 'POST',
    url: `${get_common_path(fieldId)}/direct_agreed_terms`
  });
};

const fetch_authentication_info = (fieldId, params) => {
  return requestWithToken({
    method: 'GET',
    url: `${get_common_path(fieldId)}/authentication_info`,
    params,
  });
};
const fetch_authentication_info_options = (fieldId, params) => {
  return {
    method: 'GET',
    url: `${get_common_path(fieldId)}/authentication_info`,
    params,
  }
}

const fetch_authentication_info_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 0,
      "entities": {
        "field_id": null,
        "client_id": null,
        "link_key": null,
        "state": null,
        "nonce": null
      }
    }
  }
}

// direct認証情報取得API
const authentication_info = {
  fetch: fetch_authentication_info,
  fetch_options: fetch_authentication_info_options,
  fetch_default_response: fetch_authentication_info_default_response
}

const exec_authentication_register = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: `${get_common_path(fieldId)}/authentication_register`,
    params,
  });
};

const exec_authentication_register_options = (fieldId, params) => {
  return {
    method: 'POST',
    url: `${get_common_path(fieldId)}/authentication_register`,
    params,
  }
}

const exec_authentication_register_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 0,
      "entities": {}
    }
  }
}

// 認証情報登録API
const authentication_register = {
  exec: exec_authentication_register,
  exec_options: exec_authentication_register_options,
  exec_default_response: exec_authentication_register_default_response
}

const fetch_direct_organization_list = (fieldId) => {
  return requestWithToken({
    method: 'GET',
    url: `${get_common_path(fieldId)}/organization_list`,
  });
};

const fetch_direct_organization_list_options = (fieldId) => {
  return {
    method: 'GET',
    url: `${get_common_path(fieldId)}/organization_list`,
  }
}

const fetch_direct_organization_list_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 0,
      "entities": {
        "direct_organizations": []
      }
    }
  }
}

// direct組織一覧取得API
const direct_organization_list = {
  fetch: fetch_direct_organization_list,
  fetch_options: fetch_direct_organization_list_options,
  fetch_default_response: fetch_direct_organization_list_default_response,
}

// direct組織情報登録API
const direct_organization_register = (fieldId, domainId) => {
  return requestWithToken({
    method: 'POST',
    url: `${get_common_path(fieldId)}/organization`,
    params: { 'domain_id': domainId }
  });
};

// BuildeeBOT招待組織承認API
const bulildee_bot_invitation_approval = (fieldId, useDefaultCatch) => {
  return requestWithToken(
    {
      method: 'POST',
      url: `${get_common_path(fieldId)}/bulildee_bot_invitation_approval`,
    },
    useDefaultCatch
  );
};

// direct連携解除API
const del = (fieldId) => {
  return requestWithToken({
    method: 'DELETE',
    url: get_common_path(fieldId),
  });
};

const fetch_buildee_bot_email = (fieldId) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/fields/${fieldId}/direct_api_buildee_bot_email`,
  });
};

const fetch_buildee_bot_email_options = (fieldId) => {
  return {
    method: 'GET',
    url: `/api/private/fields/${fieldId}/direct_api_buildee_bot_email`,
  }
}

const fetch_buildee_bot_email_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 0,
      "entities": {
        "buildee_bot_email": null
      }
    }
  }
}

// directBuildeeBOTメールアドレス取得API
const buildee_bot_email = {
  fetch: fetch_buildee_bot_email,
  fetch_options: fetch_buildee_bot_email_options,
  fetch_default_response: fetch_buildee_bot_email_default_response,
}

const list_direct_talkroom = (params) => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/direct_talkrooms/list`,
    params,
  });
}

const list_direct_talkroom_options = (params) => {
  return {
    method: 'GET',
    url: `/api/private/direct_talkrooms/list`,
    params,
  };
}

const list_direct_talkroom_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 0,
      "entities": {
        "direct_talkrooms": []
      }
    }
  };
}

const direct_talkroom_list = {
  list: list_direct_talkroom,
  list_options: list_direct_talkroom_options,
  list_default_response: list_direct_talkroom_default_response
}

export const DirectApiSettingsApi = {
  agreed_terms,
  authentication_info,
  authentication_register,
  direct_organization_list,
  direct_organization_register,
  bulildee_bot_invitation_approval,
  del,
  buildee_bot_email,
  direct_talkroom_list,
};

export default DirectApiSettingsApi;



// WEBPACK FOOTER //
// ./src/services/DirectApiSettings.js